import { z } from 'zod';
import { AccessEnum } from '../access';

export const AccessRuleTQLTagDTO = z.object({
  name: z.string(),
  color: z.string(),
});
export type AccessRuleTQLTag = z.infer<typeof AccessRuleTQLTagDTO>;

export const AccessRuleTQLBriefDTOResponseDTO = z.object({
  id: z.string(),
  name: z.string(),
  label: z.string(),
  tags: z.array(AccessRuleTQLTagDTO),
});
export type AccessRuleTQLBriefDTOResponse = z.infer<
  typeof AccessRuleTQLBriefDTOResponseDTO
>;

export const AccessRuleTQLBaseDTO = z.object({
  id: z.string(),
  name: z.string(),
  actions: z.array(z.string()),
  access: z.nativeEnum(AccessEnum),
  is_active: z.boolean(),
  is_expand: z.boolean(),
  user_filter: z.record(z.string(), z.unknown()),
  tql_ids: z.array(z.string()),
});
export type AccessRuleTQL = z.infer<typeof AccessRuleTQLBaseDTO>;

export const AccessRuleTQLCreateDTO = AccessRuleTQLBaseDTO.omit({ id: true });
export type AccessRuleTQLCreateRequest = z.infer<typeof AccessRuleTQLCreateDTO>;